import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NotFoundWrapper = styled.section`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #1a1a1a;
  color: white;
  text-align: center;
`;

function NotFoundPage() {
  return (
    <NotFoundWrapper>
      <h1>404</h1>
      <p>Oops! The page you’re looking for doesn’t exist.</p>
      <Link to="/" style={{ color: '#3498db', marginTop: '1rem' }}>
        Go Back to Home
      </Link>
    </NotFoundWrapper>
  );
}

export default NotFoundPage;
